import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "@/lib/utils";

// ---------------------------------------------------------------------------
// Bottom-Sheet im Look der App (mobile/components/ui/ActionSheet.tsx):
// abgedunkelter warmer Hintergrund, von unten aufgleitende Karte mit 24er-
// Rundung oben und Griff (40×5), Inhalt scrollt bei Bedarf. Für das Handy-Web
// gebaut (< 768 px), funktioniert aber auf jeder Breite.
//
// Radix-Dialog darunter liefert Fokusfalle, ESC, Tap-außen und Scroll-Sperre
// — dieselbe Grundlage wie ui/sheet.jsx, nur mit App-Optik statt shadcn.
// z-50 wie alle Dialoge/Popover hier: Ein höherer Wert legte das Sheet über
// die Auswahllisten (Select, Popover, ebenfalls z-50), die man IN ihm öffnet.
//
// `title` ist Pflicht für Screenreader (Radix warnt sonst); `titleSichtbar`
// zeigt ihn als Überschrift wie in der App.
// ---------------------------------------------------------------------------
export default function AppSheet({ open, onOpenChange, title, titleSichtbar = true, beschreibung, children, className, testId }) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-[rgba(20,18,16,0.45)] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          data-testid={testId}
          className={cn(
            "fixed inset-x-0 bottom-0 z-50 max-h-[88dvh] overflow-y-auto overscroll-contain rounded-t-[24px] bg-appbg pt-2.5 pb-[max(env(safe-area-inset-bottom),12px)] text-anthracite shadow-[0_-8px_30px_rgba(0,0,0,0.18)] outline-none",
            "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom data-[state=open]:duration-300 data-[state=closed]:duration-200",
            className,
          )}
        >
          {/* Griff — reine Optik wie in der App; Schließen per Tap außen/ESC. */}
          <div aria-hidden="true" className="mx-auto mb-3 h-[5px] w-10 rounded-full bg-surface3" />
          <DialogPrimitive.Title className={titleSichtbar ? "px-5 pb-2 font-body text-[18px] font-bold leading-tight tracking-[-0.3px]" : "sr-only"}>
            {title}
          </DialogPrimitive.Title>
          {beschreibung ? (
            <DialogPrimitive.Description className="px-5 pb-2 text-[13px] text-appmuted">{beschreibung}</DialogPrimitive.Description>
          ) : (
            <DialogPrimitive.Description className="sr-only">{title}</DialogPrimitive.Description>
          )}
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

export const AppSheetClose = DialogPrimitive.Close;
